import { ChevronDownIcon } from '@heroicons/react/16/solid';
import { router } from '@inertiajs/react';
import { Children, isValidElement } from 'react';
import TabNavItem from './TabNavItem';

const TabNav = ({ label = 'Tabbladen', className, children, ...props }) => {
    const items = Children.toArray(children).filter(isValidElement);
    const activeIndex = items.findIndex(item => item.props.active);

    const handleChange = event => {
        const { href, onClick } =
            items[Number(event.target.value)]?.props ?? {};

        if (href) {
            router.visit(href);

            return;
        }

        onClick?.(event);
    };

    return (
        <div className={className} {...props}>
            <div className='grid grid-cols-1 sm:hidden'>
                <select
                    aria-label={label}
                    value={activeIndex === -1 ? '' : activeIndex}
                    onChange={handleChange}
                    className='focus:outline-primary-600 col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pr-8 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 sm:text-sm/6'
                >
                    {items.map((item, index) => (
                        <option key={index} value={index}>
                            {item.props.label ?? item.props.children}
                        </option>
                    ))}
                </select>
                <ChevronDownIcon
                    aria-hidden='true'
                    className='pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500'
                />
            </div>
            <div className='hidden sm:block'>
                <div className='border-b border-gray-200'>
                    <nav aria-label={label} className='-mb-px flex space-x-8'>
                        {children}
                    </nav>
                </div>
            </div>
        </div>
    );
};

TabNav.Item = TabNavItem;

export default TabNav;
